import { useTheme } from '@mui/material';

const JiraIcon = ({ disabled }) => {
    const theme = useTheme();

    if (disabled) {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill={'none'}>
                <path
                    d="M19.1123 9.44018L10.506 0.833929L9.67211 0L3.19354 6.47857L0.231043 9.44018C0.0830678 9.58892 0 9.79019 0 10C0 10.2098 0.0830678 10.4111 0.231043 10.5598L6.14979 16.4786L9.67211 20L16.1498 13.5214L16.2507 13.4214L19.1123 10.5643C19.1864 10.4907 19.2453 10.4031 19.2855 10.3066C19.3256 10.2102 19.3463 10.1067 19.3463 10.0022C19.3463 9.89774 19.3256 9.79428 19.2855 9.69782C19.2453 9.60136 19.1864 9.51379 19.1123 9.44018ZM9.67211 12.9571L6.71497 10L9.67211 7.04286L12.6284 10L9.67211 12.9571Z"
                    fill={theme.palette.mode === 'light' ? 'black' : 'white'}
                    fillOpacity="0.38"
                />
                <path
                    d="M9.67214 7.04292C8.74212 6.11311 8.21785 4.85305 8.21383 3.53796C8.20982 2.22288 8.72639 0.959637 9.65071 0.0241699L3.18018 6.49203L6.7016 10.0135L9.67214 7.04292Z"
                    fill="url(#paint0_linear_7718_7506)"
                />
                <path
                    d="M12.6364 9.99194L9.67212 12.9571C10.6057 13.8909 11.1301 15.1573 11.1301 16.4777C11.1301 17.7981 10.6057 19.0644 9.67212 19.9982L16.1605 13.5134L12.6364 9.99194Z"
                    fill="url(#paint1_linear_7718_7506)"
                />
                <defs>
                    <linearGradient
                        id="paint0_linear_7718_7506"
                        x1="3.74477"
                        y1="5.93556"
                        x2="7.85921"
                        y2="1.81276"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop offset="0.18" stopColor="#CCCCCC" />
                        <stop offset="1" stopColor="#A1A2A3" />
                    </linearGradient>
                    <linearGradient
                        id="paint1_linear_7718_7506"
                        x1="10.2364"
                        y1="15.9134"
                        x2="14.3578"
                        y2="11.7928"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop offset="0.18" stopColor="#CCCCCC" />
                        <stop offset="1" stopColor="#A1A2A3" />
                    </linearGradient>
                </defs>
            </svg>
        );
    }

    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_5536_3787)">
                <path
                    d="M19.1123 9.44018L10.506 0.833929L9.67211 0L3.19354 6.47857L0.231043 9.44018C0.0830678 9.58892 0 9.79019 0 10C0 10.2098 0.0830678 10.4111 0.231043 10.5598L6.14979 16.4786L9.67211 20L16.1498 13.5214L16.2507 13.4214L19.1123 10.5643C19.1864 10.4907 19.2453 10.4031 19.2855 10.3066C19.3256 10.2102 19.3463 10.1067 19.3463 10.0022C19.3463 9.89774 19.3256 9.79428 19.2855 9.69782C19.2453 9.60136 19.1864 9.51379 19.1123 9.44018ZM9.67211 12.9571L6.71497 10L9.67211 7.04286L12.6284 10L9.67211 12.9571Z"
                    fill="#2684FF"
                />
                <path
                    d="M9.67211 7.04286C8.74209 6.11305 8.21782 4.85299 8.2138 3.5379C8.20979 2.22282 8.72636 0.959576 9.65068 0.0241089L3.18015 6.49197L6.70157 10.0134L9.67211 7.04286Z"
                    fill="url(#paint0_linear_5536_3787)"
                />
                <path
                    d="M12.6364 9.99194L9.67212 12.9571C10.6057 13.8909 11.1301 15.1573 11.1301 16.4777C11.1301 17.7981 10.6057 19.0644 9.67212 19.9982L16.1605 13.5134L12.6364 9.99194Z"
                    fill="url(#paint1_linear_5536_3787)"
                />
            </g>
            <defs>
                <linearGradient
                    id="paint0_linear_5536_3787"
                    x1="9.14265"
                    y1="4.05089"
                    x2="5.01318"
                    y2="8.17947"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.18" stopColor="#0052CC" />
                    <stop offset="1" stopColor="#2684FF" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_5536_3787"
                    x1="10.2364"
                    y1="15.9134"
                    x2="14.3578"
                    y2="11.7928"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.18" stopColor="#0052CC" />
                    <stop offset="1" stopColor="#2684FF" />
                </linearGradient>
                <clipPath id="clip0_5536_3787">
                    <rect width="20" height="20" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default JiraIcon;
